(function () {
  const initProductAccordion = () => {
    // Use event delegation so the handler survives any DOM replacement
    // (e.g. Combined Listings product switches that re-render inner HTML).
    $(document)
      .off("click.productAccordion", ".about__accordion-toggle")
      .on("click.productAccordion", ".about__accordion-toggle", function () {
        if (!$(this).hasClass("active")) {
          $(this).addClass("active");
          $(this)
            .siblings(".about__accordion-description")
            .eq($(this).index())
            .stop()
            .slideDown(300);
        } else {
          $(this).removeClass("active");
          $(this).siblings(".about__accordion-description").stop().slideUp(300);
        }
      });
  };

  const initZoomImage = () => {
    if (document.querySelector(".product-media-modal__content") == null) return;

    const imagesWrapper = document.querySelector(
      ".product-media-modal__content"
    );

    if (imagesWrapper.querySelectorAll(".js-image-zoom") == null) return;
    const images = imagesWrapper.querySelectorAll(".js-image-zoom");

    images.forEach((el) => {
      el.addEventListener("click", (e) => {
        imagesWrapper.classList.toggle("zoom");
      });
    });
  };

  const revealPopup = () => {
    const stickyBar = document.querySelector(".product__popup"); // Sticky bar
    const secondSection = document.querySelector(".product-section + section"); // Second section
    const footer = document.querySelector("footer"); // Footer

    if (!stickyBar || !secondSection || !footer) {
      return;
    }

    const getOffset = (element) => {
      const rect = element.getBoundingClientRect();
      return rect.top + window.scrollY;
    };

    const secondSectionMid = getOffset(secondSection);
    const footerTop = getOffset(footer);

    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const activeOffset =
        window.scrollY > secondSectionMid && scrollPosition < footerTop;

      stickyBar.classList[activeOffset ? "add" : "remove"]("active");
    };

    // Initial check in case the user starts in the middle of the page
    handleScroll();
  };

  const initStickyAddBar = () => {
    let section = document.querySelector(".product-section");

    if (!section || !section.classList.contains("product-section")) return;

    const buyButtons = section.querySelector(
      ".product__buy_buttons > product-form"
    );
    const stickyBar = section.querySelector(".product-sticky-add-bar");
    const footerBottom = document.querySelector(
      ".shopify-section-group-footer-group .footer__content-bottom"
    );

    if (!stickyBar) return;

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.01,
    };

    const isElementBelowScroll = (element) => {
      return element ? element.getBoundingClientRect().top > 0 : false;
    };

    const toggleStickyBar = (isVisible) => {
      if (isVisible || isElementBelowScroll(buyButtons)) {
        stickyBar.classList.remove("active");
      } else {
        stickyBar.classList.add("active");
      }
    };

    const handleIntersect = (entries) => {
      const isVisible = entries.some((entry) => entry.isIntersecting);
      toggleStickyBar(isVisible);
    };

    const observer = new IntersectionObserver(handleIntersect, observerOptions);

    if (buyButtons) observer.observe(buyButtons);
    if (footerBottom) observer.observe(footerBottom);
  };

  document.addEventListener("scroll", () => revealPopup());

  document.addEventListener("shopify:section:load", function () {
    initProductAccordion();
    initZoomImage();
    initStickyAddBar();
    revealPopup();
  });

  initProductAccordion();
  initZoomImage();
  revealPopup();
  initStickyAddBar();
})();
